import React from "react";
import { Helmet } from "react-helmet";

import { SITE_URL, DEFAULT_SEO_IMAGE } from "../../utils/seoData";

const SeoHead = ({ title, description, path, image = DEFAULT_SEO_IMAGE, noIndex = false }) => (
  <Helmet>
    <title>{title}</title>
    {description && (
      <meta
        name={"description"}
        content={description}
      />
    )}
    {noIndex && (
      <meta
        name={"robots"}
        content={"noindex, nofollow"}
      />
    )}
    <meta
      property={"og:title"}
      content={title}
    />
    {description && (
      <meta
        property={"og:description"}
        content={description}
      />
    )}
    {path && (
      <meta
        property={"og:url"}
        content={`${SITE_URL}${path}`}
      />
    )}
    <meta
      property={"og:image"}
      content={image}
    />
    <meta
      name={"twitter:card"}
      content={"summary_large_image"}
    />
    <meta
      name={"twitter:title"}
      content={title}
    />
    {description && (
      <meta
        name={"twitter:description"}
        content={description}
      />
    )}
  </Helmet>
);

export default SeoHead;
